export default "__VITE_ASSET__B2cb4gz___"